import { AnyAction, Store, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import thunk, { ThunkDispatch } from 'redux-thunk';
import persistorConfig from './persistorConfig';
import rootReducers, { RootState } from './combineReducer';
import { getEnv } from '../config';

const { env } = getEnv();
const persistedReducer = persistReducer(persistorConfig, rootReducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: env !== 'prod',
  middleware: [thunk],
});

export type AppThunkDispatch = ThunkDispatch<RootState, any, AnyAction>;
export type AppStore = Omit<Store<RootState, AnyAction>, 'dispatch'> & {
  dispatch: AppThunkDispatch;
};

// export type AppDispatch = typeof store.dispatch;
// export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export const persistor = persistStore(store);
